<template>
    <div>
        <div class="reward-img">
            <img class="img-fluid" :src="displayImage()" alt="">
        </div>
        <div class="item-list">
            <!-- <div class="img-banner img-banner-item">
                <div class="img-item">
                    <img :src="displayImage()" alt="">
                </div>
            </div> -->
            <div class="item-content">
                <div class="item-title">{{winner.title}}</div>
                <div class="item-quantity">
                    <span>{{lbl.announce.quantity}}&nbsp;</span>
                    <span>{{winner.quantity}}</span>
                    <span>&nbsp;{{lbl.announce.reward}}</span>
                </div>
                <div class="item-divider"></div>
                <div class="item-winner-list">
                    <div class="item-winner"
                        v-for="(item, key) in winner.list" :key="key">
                        <span>{{lbl.announce.name_title}}&nbsp;</span>
                        <span>{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConfigManager from '@/config/ConfigManager'
// mixin
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'AnnouncementItem',
    mixins: [LocaleMixin],
    props: {
        winner: { type: Object, required: true }
    },
    mounted: function () {
        setTimeout(() => {
            this.displayImage()
        }, 200);
    },
    methods: {
        displayImage: function () {
            if (!this.winner && !this.winner.image) return;
            var image_url = ConfigManager.getBlobUrl() + `/webconfig/${ConfigManager.getBlobConfigDev()}/announce/image/${this.winner.id}`;
            image_url = image_url + '/' + this.winner.image;
            return image_url;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../style/announe.scss";

</style>
